import { connect } from 'react-redux';

import View from './IncomeWorkflowView';

export default connect()(View);
